import React from "react"
import {notification} from "../functions/notification/notificationFunction";
import dClient from "../api/reduxLoaderApi";
import RESETAPP from "./resetApp";

export default function failStatus(content,dispatch) {
  if (content.status_code === 422) {
    content.data.details.forEach(item=>{
      dispatch(notification("error", "", <h3>{item.message}</h3>, false));
    })
    return true
  } else if (content.status_code === 500) {
      dispatch(notification("error", "", <h3>خطایی رخ داد</h3>, false));
    return true
  } else if (content.status_code === 401){
    dispatch(notification("error", "", <h3>دوباره وارد شوید</h3>, false))
    return setTimeout(() => RESETAPP(), 3000);

  }else if (content.status_code === 412) {
    dispatch(notification("error", "", <h3>{content.data.message}</h3>, false));
    return true
  }else if (content.status_code === 503) {
    dispatch(notification("error", "", <h3>خطا در برقراری ارتباط با سرور</h3>, false));
    return true
  }
}
// export default const failStatus = (content) => async (dispatch, getState) => {
//   const res = await dClient('post', '/cart/store', {}, {},1, false);
//   if (failStatus(res)) return '';
//   console.log(res);
//   // const tok = `Bearer ${res.data.token}`;
//   // return dispatch(setToken({ token: tok }));
// };
